<template>
  <div class="absolute right-80px top-100px w-440px z-9999" v-drag>
    <div
      class="alert-item-cont mt-10px mr-5px px-20px py-10px text-hex-fff rounded-6px text-14px flex max-h-270px cursor-pointer"
      v-for="(item, index) in alarmList"
      :class="{'alarm-blink': item.showShadow}"
      :key="index"
    >
      <el-tooltip
        effect="dark"
        :content="`${item.alarmTime}${item.alarmDescribe}`"
        placement="top"
        :open-delay="300"
      >
        <div class="flex">
          <div class="w-65px truncate">{{ item.alarmTime }}</div>
          <div class="w-220px truncate mr-5px">{{ item.alarmDescribe }}</div>
        </div>
      </el-tooltip>
      <el-tooltip
        effect="dark"
        :content="`${item.alarmSourceName}`"
        placement="top"
        :open-delay="300"
      >
        <div class="w-70px truncate text-hex-fdf5b0 font-600">{{ item.alarmSourceName }}</div>
      </el-tooltip>
      <audio
        v-if="item.isPlaySound"
        :id="item.id"
        :src="item.audioSrc"
        class="hidden"
        controls
        muted
        autoplay
        loop
      ></audio>
      <div class="iconfont icon-line-right text-12px" @click="jumpClick(item)"></div>
      <div class="iconfont icon-line-close text-12px ml-10px" @click="closeAlarm(index)"></div>
    </div>
  </div>
</template>

<script>
import { get, omit, head, find, isEmpty, forEach, isNil, assign, findIndex } from 'lodash'
import {
  SectionApi,
  SchemeApi,
  AlarmSourceConfigurationTableApi,
  AlarmPushSettingsApi,
  } from '@wiz-api/cloud-render-management'
import { FileApi } from '@wiz-api/file-management'
import dayjs from 'dayjs'
const signalR = require('@microsoft/signalr')

const alarmSourceConfig = new AlarmSourceConfigurationTableApi()
const alarmPushSettingsApi = new AlarmPushSettingsApi()
const schemeApi = new SchemeApi()
const sectionApi = new SectionApi()
const fileApi = new FileApi()

export default {
  data() {
    return {
      alarmList: [], // 报警列表
      frequency: 500, // // 闪烁频率
      alarmOpacity: false,
      allSourceList: [], // 所有的报警来源
      // 报警推送设置
      pushesConfig: {
        msgCount: 3, // 共存消息数
        msgDuration: 6, // 消息停留时间
      },
      currentScheme: '', // 当前打开的方案
      allSection: '', // 当前方案下的所有版块
      currentSoundAlarmId: '', // 当前正在播放声效的报警的id
    }
  },
  computed: {
    alarmNotificationPath() {
      return (
        get(Wiz, 'globalSettings.dynamicModules.modules["visualization-tongre-vulkan"].config')
          ?.alarmNotificationPath || ''
      )
    },
  },
  watch: {
    alarmList(value) {
      if (value && value.length) {
        this.$emit('getAlarmNum', value.length)
      }
    },
  },
  async created() {
    await this.getConfig()
    await this.getAllSource()
    await this.connectSignalr()
    this.currentScheme = await this.getCurrentScheme()
    this.allSection = await this.getSection(this.currentScheme)
      },
  methods: {
        // 获取所有来源
    async getAllSource() {
      const [err, res] = await alarmSourceConfig.getAlarmSourceConfigurationList({
        maxResultCount: 1000,
        skipCount: 0,
      })
      if (!err && res && res.items) {
        this.allSourceList = res.items
      }
    },
    // 获取配置
    async getConfig() {
      const [err, res] = await alarmPushSettingsApi.getList()
      if (!err && !isNil(res) && !isNil(res.items)) {
        if (res.items.length) {
          this.pushesConfig = res.items[0]
        }
      }
    },
    // 连接websocket
    connectSignalr() {
      // 连接signalr
      this.signalrObject = new signalR.HubConnectionBuilder()
        .withUrl(`${this.alarmNotificationPath}/api/chatHub`, {
          skipNegotiation: true,
          transport: signalR.HttpTransportType.WebSockets,
        })
        .configureLogging(signalR.LogLevel.Information)
        .build()
      // 连接成功后，开始接收消息
      this.signalrObject
        .start()
        .then(() => {
          // Connected to the chat Hub
          this.signalrObject.on('ReceiveMessageToAll', (message) => {
            // 处理接收到的消息
            if (!isEmpty(message)) {
              const data = JSON.parse(message)
              data.alarmTime = data.AlarmTime
              data.alarmSourceName = data.AlarmSourceName
              data.id = data.Id
              data.alarmDescribe = data.AlarmDescribe
              this.dealAlarm(data)
            }
          })
        })
        .catch((error) => {
          // error
        })
    },
    // 手动关闭某一条报警
    closeAlarm(index) {
      // 如果删除的是正在播放声效的报警
      if(this.currentSoundAlarmId === this.alarmList[index]?.id) {
        this.currentSoundAlarmId = ''
      }
      this.alarmList.splice(index, 1)
    },
    // 处理报警通知
    async dealAlarm(data) {
      // 获取来源配置信息
      const sourceDetail = find(this.allSourceList, ['alarmSource', data.alarmSourceName])
      if (!isEmpty(sourceDetail)) {
        // 如果来源没有开启推送，则不展示
        if (sourceDetail.isOpen) {
          data = assign(data, omit(sourceDetail, 'id'))
          // 格式化时间，只显示时分秒
          data.alarmTime = dayjs(data.alarmTime).format('HH:mm:ss')

          // 如果获取声效文件失败也不会阻断后面代码的进行，所有用trycatch包裹
          try {
            // 同时只能播放一个报警声效
            // 如果该报警有声效并且当前并没有正在播放的声效
            if (!isEmpty(data.alarmSoundId) && isEmpty(this.currentSoundAlarmId)) {
              this.currentSoundAlarmId = data.id
              data.isPlaySound = true
              data.audioSrc = await this.getSound(data.alarmSoundId)
            }
          } catch (error) {}

          // 加入报警通知队列
          // 如果超出最大共存消息数，删除最后一条
          if (this.alarmList.length === this.pushesConfig.msgCount) {
            const lastAlarm = this.alarmList.pop()
            // 如果被删除的是正在播放声效的报警
            if(this.currentSoundAlarmId === lastAlarm.id) {
              this.currentSoundAlarmId = ''
            }
          }
          this.alarmList.unshift(data)

          // 根据推送配置设置消息停留时间
          data.showMsgTimer = setTimeout(() => {
            const index = findIndex(this.alarmList, ['id', data.id])
            // 该报警的声效关闭，可以让下一次的报警播放声效
            if (this.currentSoundAlarmId === data.id) {
              this.currentSoundAlarmId = ''
            }
            if (index >= 0) {
              this.alarmList.splice(index, 1)
            }
            clearTimeout(data.showMsgTimer)
            data.showMsgTimer = null
          }, this.pushesConfig.msgDuration * 1000)

          // 设置光影持续时间
          if (!isNil(data.shadow) && !isNaN(Number(data.effectDuration))) {
            data.showShadow = true
            let timer = setTimeout(() => {
              data.showShadow = false
              clearTimeout(timer)
              timer = null
            }, Number(data.effectDuration) * 1000)
          }

          // 设置声效持续时间
          if (!isEmpty(data.audioSrc)) {
            let audioLabel = null
            this.$nextTick(() => {
              const audioLabel = document.getElementById(`${data.id}`)
              if (!isEmpty(audioLabel)) {
                audioLabel.play().catch(() => {})
              }
            })
            let timer = setTimeout(() => {
              data.isPlaySound = false
              // 该报警的声效关闭，可以让下一次的报警播放声效
              if (this.currentSoundAlarmId === data.id) {
                this.currentSoundAlarmId = ''
              }
              clearTimeout(timer)
              timer = null
            }, Number(data.effectDuration) * 1000)
          }
        }
      }
    },
    // 点击报警跳转至消息中心
    async jumpClick(data) {
      // 跳转至后台
      if (data.jumpMethod === 0) {
        if (!isEmpty(data.jumpLink)) {
          this.$router.push(data.jumpLink)
        } else {
          return this.$message.warning({
            showClose: true,
            $message: '报警来源未配置跳转路由，无法跳转，请重新配置',
          })
        }
      } else {
        // 跳转至配置三维板块
        // 判断跳转方案是否是当前的打开的方案
        if (this.currentScheme !== data.schemeSelection) {
          return this.$message.warning({
            showClose: true,
            message: '报警来源配置非当前方案，无法跳转，请重新配置',
          })
        }
        // 判断跳转板块是否存在
        const section = find(this.allSection, ['id', data.blockSelection])
        if (isEmpty(section)) {
          return this.$message.warning({
            showClose: true,
            message: '报警来源配置板块不存在，无法跳转，请重新配置',
          })
        }
        const allFunction = get(section, 'extraDto.businessFunctionInfoDtos')
        const currentFunction = find(allFunction, ['id', data.moduleSelection])
        // 判断跳转模块是否存在
        if (isEmpty(currentFunction)) {
          return this.$message.warning({
            showClose: true,
            message: '报警来源配置模板不存在，无法跳转，请重新配置',
          })
        }
        if (currentFunction.functionLocationType !== 0) {
          this.$emit('alarmJump', section, currentFunction.code)
        }
      }
    },
    // 获取当前方案
    async getCurrentScheme() {
      const keyword = get(this.$route, 'query.programmeCode')
      // 未匹配当前用户设置方案，使用默认方案
      const params = omit(
        {
          keyword,
          isEnable: true,
          maxResultCount: 1,
          skipCount: 0,
        },
        keyword ? 'isEnable' : 'name'
      )
      const [err, res] = await schemeApi.getList(params)
      if (!err && res && res.items) {
        return get(head(res.items), 'id')
      }
    },
    // 获取当前方案所有的板块
    async getSection(schemeId) {
      const [err, res] = await sectionApi.getList({ schemeId })
      if (!err && res && res.items) {
        return res.items
      }
    },
    // 获取声效文件
    async getSound(fileId) {
      const [err, res] = await fileApi.getFileContent(fileId)
      if (!err) {
        return `data:audio/mp3;base64,${res.content}`
      }
    },
  },
  beforeDestroy() {
    // 断开连接
    if (this.signalrObject) {
      this.signalrObject.stop()
    }
  },
}
</script>

<style lang="scss" scoped>
.alert-item-cont {
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-position: center 0;
  background-image: url('../../assets/images/alarm-bg.png');
}

.alarm-blink {
  animation: blink-animation 1s linear infinite;
}

@keyframes blink-animation {
  0% {
    box-shadow: 0 0 0 0 #ec2a2a inset;
  }
  50% {
    box-shadow: 1px 1px 5px 4px #f31111 inset;
  }
  100% {
    box-shadow: 1px 1px 10px 8px #f80101 inset;
  }
}
</style>
